// 그리팅 관리 관련 타입 정의

// 노출 상태 타입
export type ExposureType = 'show' | 'hide';
export type ExposureDisplayType = '노출' | '비노출';

// 사용자 정보 인터페이스
export interface UserInfo {
  id: number;
  name: string;
  email: string;
}

// 그리팅 아이템 인터페이스
export interface GreetingItem {
  id: number;
  layoutName: string;
  exposureType: ExposureType;
  startDate?: string | null;
  endDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  title: string;
  visitorCompanyName?: string | null;
  content: string[];  // 최대 2개 배열, 각 18자 제한
  createdAt: string;
  updatedAt?: string;
  createdBy: number;
  creator?: UserInfo;
}

// 그리팅 목록 응답 인터페이스
export interface GreetingListResponse {
  data: GreetingItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// 그리팅 생성 요청 인터페이스
export interface CreateGreetingRequest {
  layoutName: string;
  exposureType: ExposureType;
  startDate?: string | null;
  endDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  title: string;
  visitorCompanyName?: string | null;
  content: string[];  // 최대 2개 배열, 각 18자 제한
}

// 그리팅 수정 요청 인터페이스
export interface UpdateGreetingRequest extends Partial<CreateGreetingRequest> {
  id: number;
}

// 그리팅 필터 옵션
export interface GreetingFilterOptions {
  exposureType?: ExposureType | 'all';
  searchKeyword?: string;
  page?: number;
  limit?: number;
}

// 그리팅 관리 유틸리티 함수
export const getExposureDisplayText = (exposureType: ExposureType): ExposureDisplayType => {
  return exposureType === 'show' ? '노출' : '비노출';
};

export const getExposureTypeFromDisplay = (displayType: ExposureDisplayType): ExposureType => {
  return displayType === '노출' ? 'show' : 'hide';
};